// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__r63M6","overlaySafeliteEF":"Modal_overlaySafeliteEF__qo4zJ","overlayVisible":"Modal_overlayVisible__whK9-"};